<template>
    <div class="p-grid p-fluid p-justify-center">
        <div class="p-col-12" style="max-width: 460px;">
            <Header style="margin: 2em 0;"/>
            <slot></slot>
            <Footer style="margin-top: 4em;"></Footer>
        </div>
    </div>
</template>

<script>
    import Header from "./Header"
    import Footer from "./Footer"

    export default {
        components: {
            Header,
            Footer
        }
    }
</script>
